import React from 'react';
import styled from 'styled-components';

const Button = styled.a`
  padding: 15px 30px;
  font-size: 1.2rem;
  border-radius: 30px;
  background: #e1d6c0;
  color: #0d0d0d;
  font-weight: 700;
  transition: opacity 0.2s;
  &:hover { opacity: 0.8; }
`;

const OrderButtonCaviar = () => (
  <Button href="https://www.trycaviar.com/store/zoku-contemporary-japanese-tracy-25039044/?utm_campaign=gpa&rwg_token=AAiGsobDIW9OufaKpgU27SrTbpV39NArju-NqH_PgcK_1jaWVN8HivwJouqMh6VfQD1jbA0xd5fu2BosEsP_VWhgoohx0hFyYQ%3D%3D" target="_blank" rel="noopener noreferrer">
    Order Delivery (Caviar)
  </Button>
);

export default OrderButtonCaviar;